export default __webpack_public_path__ + "MQ_Logoandmark_RGB_KO-01.svg";